import {fromJS, Map} from 'immutable';
import rewardsActions from '../../actions/fortnite-game/rewards.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {Datapoint} from '@epic-visualizations/charts';

export interface RewardsState {
    data: Datapoint[];
    loading: boolean;
    error?: string;
}

export const DEFAULT_STATE = fromJS({
    data: [],
    loading: false,
    error: undefined
});

export const rewardsReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case rewardsActions.TYPES.GET_REWARDS: {
            return state.merge({
                error: undefined,
                loading: !silent
            });
        }

        case rewardsActions.TYPES.GET_REWARDS_COMPLETE: {
            return state.merge({
                data,
                loading: false,
                error
            });
        }

        case rewardsActions.TYPES.GET_REWARDS_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('rewards', rewardsReducer);
